import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import USEnglish from './en-us.js';
import NeutralSpanish from './es.js';
import USSapphire from './en-sap.js';


// TODO: Add in when we receive the Spanish translations
// import MXSpanish from './es-mx.js';

const messages = {
	'en-us': USEnglish,
	'sa-us': USSapphire,
	'es': NeutralSpanish,
	// TODO: Add in when we receive the Spanish translations
	// 'es-mx': MXSpanish
};

const i18n = new VueI18n({
	locale: 'en-us',					// set locale
	fallbackLocale: 'en-us',	// Set fallback locale
	silentTranslationWarn: process.env.NODE_ENV === 'production', // Makes the locale warnings hidden in production mode
	messages
});

export default i18n;
